// extracted by mini-css-extract-plugin
export default {"servicesSection":"Services_servicesSection__2wb77"};